
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"19.999"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1746"}},[_c('path',{attrs:{"data-name":"Path 1124","d":"M19 0H1a1 1 0 00-1 1v17.966c0 1.1.637 1.364 1.414.586L4.967 16H19a1 1 0 001-1V1a1 1 0 00-1-1z","fill":"#adadad"}}),_c('g',{attrs:{"data-name":"Group 1746","transform":"translate(-865.021 -304.768)"}},[_c('circle',{attrs:{"data-name":"Ellipse 226","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(868.021 311.486)"}}),_c('circle',{attrs:{"data-name":"Ellipse 227","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(873.021 311.486)"}}),_c('circle',{attrs:{"data-name":"Ellipse 228","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(878.021 311.486)"}})])])])
          )
        }
      }
    